class MVisitorCounter extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      liveViews: ['.m-product-live-views'],
      stockCountdowns: ['.prod__stock-countdown']
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    try {
      this.domNodes = queryDomNodes(this.selectors);
      this.initLiveViews();
    } catch (error) {}
  }

  ensureStyles() {
    if (document.getElementById('ra-visitors-counter-styles')) return;

    const style = document.createElement('style');
    style.id = 'ra-visitors-counter-styles';
    style.textContent = `
      .template-product .main-product__block-visitors {
        margin-top: 10px !important;
      }

      .template-product .main-product__block-visitors .m-product-live-views {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-wrap: nowrap !important;
        gap: 3px !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 5px 1px !important;
        overflow: hidden !important;
        color: #111 !important;
        font-size: 11px !important;
        line-height: 1.15 !important;
        text-align: center !important;
        white-space: nowrap !important;
      }

      .template-product .main-product__block-visitors .live-views-icon {
        display: none !important;
      }

      .template-product .main-product__block-visitors .ra-live-views-lightning {
        display: inline-flex !important;
        flex: 0 0 auto !important;
        align-items: center !important;
        justify-content: center !important;
        color: #c40000 !important;
        font-size: 15px !important;
        line-height: 1 !important;
      }

      .template-product .main-product__block-visitors .live-views-text,
      .template-product .main-product__block-visitors .live-views-text *,
      .template-product .main-product__block-visitors .live-view-numb {
        margin: 0 !important;
        font-size: 11px !important;
        line-height: 1.15 !important;
        white-space: nowrap !important;
      }

      @media screen and (max-width: 767px) {
        .template-product .main-product__block-visitors .m-product-live-views {
          gap: 3px !important;
          padding: 4px 1px !important;
          font-size: 9.5px !important;
          letter-spacing: -.01em !important;
        }

        .template-product .main-product__block-visitors .live-views-text,
        .template-product .main-product__block-visitors .live-views-text *,
        .template-product .main-product__block-visitors .live-view-numb {
          font-size: 9.5px !important;
        }

        .template-product .main-product__block-visitors .ra-live-views-lightning {
          font-size: 13px !important;
        }
      }

      .template-product .ra-product-help-banner {
        display: block;
        width: 100%;
        box-sizing: border-box;
        margin: 10px 0 0;
        padding: 18px 18px 16px;
        border-radius: 22px;
        background: #f6efe9;
        color: #111;
      }

      .template-product .ra-product-help-banner__top {
        display: flex;
        align-items: center;
        gap: 12px;
      }

      .template-product .ra-product-help-banner__icon-window {
        position: relative;
        flex: 0 0 48px;
        width: 48px;
        height: 52px;
        overflow: hidden;
      }

      .template-product .ra-product-help-banner__icon-source {
        position: absolute;
        top: -22px;
        left: -38px;
        width: 472px;
        max-width: none;
        height: auto;
      }

      .template-product .ra-product-help-banner__title {
        margin: 0;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.1;
        text-transform: uppercase;
      }

      .template-product .ra-product-help-banner__text {
        margin: 14px 0 0;
        font-size: 12px;
        line-height: 1.45;
      }

      .template-product .ra-description-showcase {
        width: 100%;
        margin: 16px 0 0;
      }

      .template-product .ra-description-showcase__image {
        width: 100%;
        height: 360px;
        overflow: hidden;
        background: #f4f0eb;
      }

      .template-product .ra-description-showcase__image img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center 32%;
        transform: scale(1.16);
      }

      .template-product .ra-description-showcase .main-product__block-collapsible_tab {
        position: relative;
        z-index: 1;
        width: calc(100% - 42px);
        margin: -54px auto 0 !important;
        padding: 26px 25px 28px;
        box-sizing: border-box;
        border: 1px solid #cfcfcf;
        border-radius: 26px;
        background: #fffdf8;
        color: #171717;
      }

      .template-product .ra-description-showcase .m-collapsible--button {
        display: none !important;
      }

      .template-product .ra-description-showcase collapsible-tab,
      .template-product .ra-description-showcase .m-product-collapsible,
      .template-product .ra-description-showcase .m-collapsible--content,
      .template-product .ra-description-showcase .m-collapsible--content__inner {
        display: block !important;
        width: 100% !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content {
        padding: 0 !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content__inner,
      .template-product .ra-description-showcase .m-collapsible--content__inner * {
        font-size: 13px !important;
        line-height: 1.55 !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content__inner p {
        margin: 0 0 13px !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content__inner ul,
      .template-product .ra-description-showcase .m-collapsible--content__inner ol {
        margin: 8px 0 15px !important;
        padding-left: 22px !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content__inner li {
        margin-bottom: 6px !important;
      }

      .template-product .ra-description-showcase .m-collapsible--content__inner strong,
      .template-product .ra-description-showcase .m-collapsible--content__inner b {
        font-weight: 700 !important;
      }

      @media screen and (max-width: 767px) {
        .template-product .ra-product-help-banner {
          margin-top: 8px;
          padding: 14px 14px 13px;
          border-radius: 18px;
        }

        .template-product .ra-product-help-banner__top {
          gap: 9px;
        }

        .template-product .ra-product-help-banner__icon-window {
          flex-basis: 40px;
          width: 40px;
          height: 44px;
        }

        .template-product .ra-product-help-banner__icon-source {
          top: -18px;
          left: -32px;
          width: 400px;
        }

        .template-product .ra-product-help-banner__title {
          font-size: 12px;
        }

        .template-product .ra-product-help-banner__text {
          margin-top: 10px;
          font-size: 10.5px;
          line-height: 1.4;
        }

        .template-product .ra-description-showcase {
          margin-top: 12px;
        }

        .template-product .ra-description-showcase__image {
          height: 250px;
        }

        .template-product .ra-description-showcase__image img {
          object-position: center 30%;
          transform: scale(1.2);
        }

        .template-product .ra-description-showcase .main-product__block-collapsible_tab {
          width: calc(100% - 28px);
          margin-top: -40px !important;
          padding: 21px 19px 23px;
          border-radius: 22px;
        }

        .template-product .ra-description-showcase .m-collapsible--content__inner,
        .template-product .ra-description-showcase .m-collapsible--content__inner * {
          font-size: 11px !important;
          line-height: 1.55 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  initLiveViews() {
    this.ensureStyles();

    if (!this.domNodes.liveViews) return;

    this.domNodes.liveViews.forEach((element) => {
      if (element.dataset.initialized === 'true') return;

      const text = element.querySelector('.live-views-text');
      const data = element.dataset;

      if (!element.querySelector('.ra-live-views-lightning')) {
        const lightning = document.createElement('span');
        lightning.className = 'ra-live-views-lightning';
        lightning.setAttribute('aria-hidden', 'true');
        lightning.textContent = '⚡';
        element.insertBefore(lightning, text || element.firstChild);
      }

      if (text) {
        const originalHtml = text.innerHTML;
        text.innerHTML = originalHtml.replace(
          data.liveViewsCurrent,
          `<span class="live-view-numb">${data.liveViewsCurrent}</span>`
        );
        this.changeLiveViewsNumber(text, data);
      }

      element.dataset.initialized = 'true';
    });
  }

  changeLiveViewsNumber(element, data) {
    const numberElement = element.querySelector('.live-view-numb');
    const {
      liveViewsDuration,
      liveViewsMax,
      liveViewsMin
    } = data;

    const duration = Number(liveViewsDuration) || 5;
    const max = Number(liveViewsMax) || 30;
    const min = Number(liveViewsMin) || 20;

    if (!numberElement) return;

    setInterval(() => {
      const nextNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      numberElement.textContent = nextNumber;
    }, 1000 * duration);
  }
}

if (!customElements.get('m-visitiors-counter')) {
  customElements.define('m-visitiors-counter', MVisitorCounter);
}

(() => {
  const imageUrl = 'https://cdn.shopify.com/s/files/1/0051/0935/0515/files/ra-boutique-banner-assistenza-riferimento.jpg?v=1784095218';

  const findShippingBlock = () => {
    const blocks = document.querySelectorAll('.template-product .main-product__block-collapsible_tab');
    return Array.from(blocks).find((block) => {
      const title = block.querySelector('.m-collapsible--button > span:first-child');
      const text = (title?.textContent || '').trim().toLowerCase();
      return text.includes('spedizione e pagamento');
    });
  };

  const mountHelpBanner = () => {
    if (!document.body.classList.contains('template-product')) return false;
    if (document.querySelector('.ra-product-help-banner')) return true;

    const shippingBlock = findShippingBlock();
    if (!shippingBlock) return false;

    const banner = document.createElement('aside');
    banner.className = 'ra-product-help-banner';
    banner.setAttribute('aria-label', 'Assistenza clienti');
    banner.innerHTML = `
      <div class="ra-product-help-banner__top">
        <span class="ra-product-help-banner__icon-window" aria-hidden="true">
          <img class="ra-product-help-banner__icon-source" src="${imageUrl}" alt="">
        </span>
        <h3 class="ra-product-help-banner__title">Hai bisogno di aiuto?</h3>
      </div>
      <p class="ra-product-help-banner__text">Se hai bisogno di aiuto siamo qui per te. Clicca qui nella chat in basso a destra per metterti in contatto con il nostro team.</p>
    `;

    shippingBlock.insertAdjacentElement('afterend', banner);
    return true;
  };

  const startHelpBanner = () => {
    if (mountHelpBanner()) return;

    const observer = new MutationObserver(() => {
      if (mountHelpBanner()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startHelpBanner, { once: true });
  } else {
    startHelpBanner();
  }
  document.addEventListener('shopify:section:load', startHelpBanner);
})();

(() => {
  const findDescriptionBlock = () => {
    const blocks = document.querySelectorAll('.template-product .main-product__block-collapsible_tab');
    return Array.from(blocks).find((block) => {
      const title = block.querySelector('.m-collapsible--button > span:first-child');
      const text = (title?.textContent || '').trim().toLowerCase();
      return text.includes('descrizione prodotto') || text === 'descrizione' || text.includes('product description');
    });
  };

  const getProductImage = () => {
    const selectors = [
      '.m-product-media--mobile img',
      '.m-product-media--desktop img',
      '.m-main-product--media img'
    ];

    for (const selector of selectors) {
      const images = Array.from(document.querySelectorAll(selector));
      const image = images.find((item) => {
        const source = item.currentSrc || item.src || '';
        return source && item.offsetWidth > 120 && item.offsetHeight > 120;
      });
      if (image) return image.currentSrc || image.src;
    }
    return '';
  };

  const openDescription = (block) => {
    const tab = block.querySelector('collapsible-tab');
    const content = block.querySelector('[data-content]');
    const trigger = block.querySelector('[data-trigger]');

    if (tab) {
      tab.setAttribute('open', 'true');
      tab.classList.add('is-expanded');
    }
    if (content) {
      content.hidden = false;
      content.style.height = 'auto';
      content.style.maxHeight = 'none';
      content.style.overflow = 'visible';
    }
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  };

  const mountDescriptionShowcase = () => {
    if (!document.body.classList.contains('template-product')) return false;
    if (document.querySelector('.ra-description-showcase')) return true;

    const helpBanner = document.querySelector('.ra-product-help-banner');
    const descriptionBlock = findDescriptionBlock();
    if (!helpBanner || !descriptionBlock) return false;

    const wrapper = document.createElement('section');
    wrapper.className = 'ra-description-showcase';
    wrapper.setAttribute('aria-label', 'Descrizione prodotto');

    const imageSource = getProductImage();
    if (imageSource) {
      const imageWrap = document.createElement('div');
      imageWrap.className = 'ra-description-showcase__image';
      const image = document.createElement('img');
      image.src = imageSource;
      image.alt = '';
      image.loading = 'lazy';
      imageWrap.appendChild(image);
      wrapper.appendChild(imageWrap);
    }

    helpBanner.insertAdjacentElement('afterend', wrapper);
    wrapper.appendChild(descriptionBlock);
    openDescription(descriptionBlock);
    return true;
  };

  const startDescriptionShowcase = () => {
    if (mountDescriptionShowcase()) return;

    const observer = new MutationObserver(() => {
      if (mountDescriptionShowcase()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDescriptionShowcase, { once: true });
  } else {
    startDescriptionShowcase();
  }
  window.addEventListener('load', startDescriptionShowcase);
  document.addEventListener('shopify:section:load', startDescriptionShowcase);
})();
